import { PackageOpen } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function EmptyState({ icon: Icon = PackageOpen, message, action }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div
        className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4"
        style={{ background: 'rgba(0,6,102,0.06)', color: '#767683' }}
      >
        <Icon size={32} />
      </div>
      <p
        className="text-dim font-bold text-base mb-4"
        style={{ fontFamily: 'Cairo, sans-serif' }}
      >
        {message || t('common.noData')}
      </p>
      {action && action}
    </div>
  )
}
